import { BACKEND_PRIVATE } from './base'

export async function closeRoom (room_id: string) {
  return BACKEND_PRIVATE.post('/me/chats/close-room', { payload: { room_id } })
}
